// 統一 API base URL
// 開發: 透過 setupProxy.js 代理到後端 (同 origin, 不跨域)
// 部署: 同一個 domain, nginx 做路由轉發
const api = process.env.REACT_APP_API_BASE || "/api";

export default api;
